import { useEffect, useState } from "react";
import { FormCustomerAdminLayout, MenuLayout } from "../layouts";
import { useParams } from "react-router-dom";
import { useAPI } from "../../hooks";

export const EditCustomerPage = () => {
  const { id } = useParams();
  const { get } = useAPI();
  const [customer, setCustomer] = useState(null);

  const getCustomer = async (id) => {
    const { data, isSuccess } = await get(`/admin-client/${id}`);
    if (isSuccess) {
      setCustomer(data.data);
    }
  };
  useEffect(() => {
    getCustomer(id);
  }, [id]);

  return (
    <>
      <MenuLayout>
        {customer !== null ? (
          <FormCustomerAdminLayout
            isEditMode={true}
            dataToEdit={customer}
            titlePage={`Edición del Usuario: ${customer.name}`}
          />
        ) : (
          <></>
        )}
      </MenuLayout>
    </>
  );
};
